/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProjectViewModel { 
    id?: number;
    code?: string;
    description?: string;
    name?: string;
    logo?: string;
    _default?: boolean;
    wbsLastSync?: Date;
    lastWbsSyncStatus?: string;
    usingProjectWbs?: boolean;
    closed?: boolean;
}